// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"b87333af","50":"421f3711","155":"36feaad2","352":"ec056473","931":"02c17d0c"}[chunkId] + ".css";
};